<template>
	<vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value).color">
		<span>{{ chipColor(params.value).text }}</span>
	</vs-chip>
</template>

<script>
export default {
	name: "CellRendererStatus",
	computed: {
		chipColor() {
			return (value) => {
				let color = "#a0a0a0";
				let text = "";
				switch (value) {
					case 1:
						color = "";
						text = "NOT_ASSIGNED";
						break;
					case 2:
						text = this.$t("Schedule.Scheduled");
						color = "#3AAAFF";
						break;
					case 3:
						text = this.$t("Schedule.ReProgramming");
						color = "#FFE15A";
						break;
					case 4:
						text = "DELAYED";
						color = "DELAYED";
						break;
					case 5:
						text = "ON_THE_WAY";
						color = "ON_THE_WAY";
						break;
					case 6:
						text = this.$t("Schedule.InProgress");
						color = "#8448be";
						break;
					case 7:
						text = this.$t("Schedule.Finished");
						color = "#008805";
						break;
					case 8:
						text = this.$t("Schedule.Canceled");
						color = "#FF0000";
						break;
					default:
						color = "primary";
						break;
				}
				return {color, text};
			};
		},
	},
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
	&.vs-chip-success {
		background: rgba(var(--vs-success), 0.15);
		color: rgba(var(--vs-success), 1) !important;
		font-weight: 500;
	}

	&.vs-chip-warning {
		background: rgba(var(--vs-warning), 0.15);
		color: rgba(var(--vs-warning), 1) !important;
		font-weight: 500;
	}

	&.vs-chip-danger {
		background: rgba(var(--vs-danger), 0.15);
		color: rgba(var(--vs-danger), 1) !important;
		font-weight: 500;
	}
}

.bg-agendado {
	background-color: #3aaaff !important;
}

.bg-reprogramado {
	background-color: #ffe15a !important;
}

.bg-cancelado {
	background-color: #ff0000 !important;
}

.bg-finalizado {
	background-color: #28c76f !important;
}

.bg-en_proceso {
	background-color: #113a60 !important;
}

.bg-selected {
	background-color: #a0a0a0 !important;
}

.bg-ondemand {
	background-color: #886ce4 !important;
}
</style>
